import React, { useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';
import Header from '../Header';
import Footer from '../Footer';
import { getArticle } from '../../content/blog/articleRegistry';

const BlogPostPage = () => {
    const { slug } = useParams();
    const entry = slug ? getArticle(slug) : null;
    const ArticleComponent = entry?.Article;

    useEffect(() => {
        if (!entry) return;
        const { title, description } = entry.meta();
        document.title = `${title} | meDZhub`;
        const d = document.querySelector('meta[name="description"]');
        if (d) d.setAttribute('content', description);
    }, [entry, slug]);

    return (
        <>
            <Header />
            <Box
                component="main"
                sx={{
                    py: { xs: 6, md: 10 },
                    minHeight: '50vh',
                    background: 'linear-gradient(180deg, #FFFFFF 0%, #F7F9FF 35%, #FFFFFF 100%)',
                }}
            >
                <Container maxWidth="md">
                    {ArticleComponent ? (
                        <ArticleComponent />
                    ) : (
                        <>
                            <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
                                Article not found
                            </Typography>
                            <Typography color="text.secondary" paragraph>
                                This link may be outdated.
                            </Typography>
                            <Button component={RouterLink} to="/resources" variant="contained">
                                Back to Resources
                            </Button>
                        </>
                    )}
                </Container>
            </Box>
            <Footer />
        </>
    );
};

export default BlogPostPage;
